<template>
    <div>
        <ul class="nav nav-tabs" id="myTab" role="tablist">
            <li v-for="(tab, index) in tabs" :key="index" class="nav-item" role="presentation">
                <a class="nav-link" :class="{active: tab.selected}" :id="tab.name+'-tab'" data-toggle="tab"
                   :href="'#'+tab.name" role="tab" :aria-controls="tab.name" :aria-selected="tab.selected">{{
                        tab.name |
                            capitalize
                    }}</a>
            </li>
        </ul>
        <div class="tab-content" id="myTabContent">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            tabs: []
        };
    },
    created() {
        this.tabs = this.$children;
    },
    filters: {
        capitalize(value) {
            if (!value) return;
            value = value.toString();
            return value.charAt(0).toUpperCase() + value.slice(1);
        }
    }
}
</script>
